/** Search tab id is reserved — it is not a Contentful primary item. */
export const SEARCH_TAB_ID = 'search';

export const FALLBACK_SHOP_TAB_ID = 'fallback-shop';

export const NAV_DRAWER_WIDTH = {
  l1: '456px',
  l2: '777px',
  gallery: '100vw',
  search: '1080px',
};

/** L1 category hover → L2. Keyboard / click has no delay. */
export const NAV_L1_HOVER_INTENT_MS = 200;

/** L1 link stagger on drawer open. */
export const NAV_L1_STAGGER = {
  startDelayMs: 120,
  perItemMs: 40,
  capMs: 240,
};

/** Category change while the drawer is already open. */
export const NAV_L2_CROSSFADE_MS = 180;

/** Mobile L2: panel slides in from the right. */
export const NAV_MOBILE_L2_SLIDE_MS = 300;
